export const downloadProvisionalResultsPdf = async ({ institution, student, results = [] }) => {
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = 210;
  const left = 12;
  const right = 198;
  const center = pageWidth / 2;
  let y = 12;

  if (institution?.logo_url) {
    try {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = institution.logo_url;
      await new Promise(resolve => { img.onload = resolve; img.onerror = resolve; });
      if (img.width && img.height) {
        const h = 18;
        pdf.addImage(img, 'PNG', center - ((img.width / img.height) * h) / 2, y, (img.width / img.height) * h, h);
        y += h + 5;
      }
    } catch (_) { /* keep the slip usable if the logo host blocks canvas access */ }
  }

  pdf.setFont('times', 'bold');
  pdf.setFontSize(14);
  pdf.text((institution?.name || 'Institution').toUpperCase(), center, y, { align: 'center' });
  y += 6;
  pdf.setFontSize(11);
  pdf.text('PROVISIONAL SEMESTER RESULTS SLIP', center, y, { align: 'center' });
  pdf.line(center - 49, y + 1, center + 49, y + 1);
  y += 8;

  pdf.setFontSize(9.5);
  pdf.setFont('times', 'bold');
  pdf.text('NAME OF STUDENT:', left, y);
  pdf.setFont('times', 'normal');
  pdf.text(String(student?.student_name || student?.full_name || '—').toUpperCase(), left + 42, y);
  y += 5;
  pdf.setFont('times', 'bold');
  pdf.text('REGISTRATION NO:', left, y);
  pdf.setFont('times', 'normal');
  pdf.text(student?.admission_number || '—', left + 42, y);
  y += 7;

  const widths = [10, 27, 68, 22, 22, 25];
  const headers = ['SN', 'UNIT', 'UNIT OF COMPETENCY', 'FORMATIVE /60', 'SUMMATIVE /40', 'TOTAL /100'];
  const xs = [left];
  widths.forEach(width => xs.push(xs[xs.length - 1] + width));
  const rowHeight = 12;
  pdf.setFont('times', 'bold');
  pdf.setFontSize(7.5);
  pdf.setFillColor(225, 230, 238);
  pdf.rect(left, y, right - left, rowHeight, 'F');
  headers.forEach((header, index) => pdf.text(header, xs[index] + widths[index] / 2, y + 5.8, { align: 'center', maxWidth: widths[index] - 2 }));
  y += rowHeight;

  pdf.setFont('times', 'normal');
  pdf.setFontSize(8.5);
  results.forEach((row, index) => {
    if (y > 268) { pdf.addPage(); y = 16; }
    const attemptMarker = row.attempt_marker || '';
    const values = [
      String(index + 1), `${row.unit_code || '—'}${attemptMarker}`, row.unit_name || '—',
      `${row.formative_total_60 ?? 0}`, `${row.summative_total_40 ?? 0}`, `${row.overall_total_100 ?? 0}`,
    ];
    values.forEach((value, col) => pdf.text(String(value), xs[col] + widths[col] / 2, y + 5.8, { align: 'center', maxWidth: widths[col] - 2 }));
    pdf.setFontSize(7.5);
    pdf.text(`${row.competency || 'Not Yet Competent (NYC)'}`, xs[2] + 2, y + 10, { maxWidth: widths[2] - 4 });
    pdf.setFontSize(8.5);
    pdf.line(left, y + rowHeight, right, y + rowHeight);
    y += rowHeight;
  });
  if (!results.length) {
    pdf.text('No released results are available for this period.', center, y + 6, { align: 'center' });
    y += rowHeight;
  }

  y += 8;
  pdf.setFont('times', 'bold');
  pdf.setFontSize(8.5);
  pdf.text('Competency decision:', left, y);
  pdf.setFont('times', 'normal');
  pdf.text('A unit is competent only when Formative ≥ 30/60 and Summative ≥ 20/40.', left + 34, y);
  y += 5;
  pdf.text('NYC = Not Yet Competent · Competent = 50–64 · Proficient = 65–79 · Attained Mastery = 80–100.', left, y);
  y += 5;
  pdf.text('* = first resit · ** = second resit · additional asterisks identify later attempts.', left, y);
  y += 12;
  pdf.setFont('times', 'italic');
  pdf.setFontSize(8);
  pdf.text('This is a provisional results slip and is subject to the institution\'s final examination and senate records.', center, y, { align: 'center', maxWidth: right - left });
  pdf.save(`${String(student?.student_name || 'Student').replace(/[^a-z0-9]+/gi, '_')}_Provisional_Results_Slip.pdf`);
};
